import { render } from "./VsList.vue?vue&type=template&id=28b08cf6"
import script from "./VsList.vue?vue&type=script&lang=js"
export * from "./VsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__